// extracted by mini-css-extract-plugin
export default {"admin":"admin_admin__k57k4","content":"admin_content__s4PVC","routes":"admin_routes__cCytT"};